<footer class="test-environment-footer" style="z-index: 1;">
   <!--  <p-chip class="mr-3"  > </p-chip>  -->
   <p >AMBIENTE DIMOSTRATIVO</p>     
   <!-- <div class="p-2 font-bold" [style.color]="'#6FB4FF'" >versione {{ 21 }}</div> -->
   
    <!--  -->
</footer>